export const setWorker = (data, status, contract, role) => {

    var worker = {}

    worker.address = data.address,
    worker.app_access = data.app_access,
    worker.badge_number = (data.badge_number) ? data.badge_number : null,
    worker.city = data.city,
    worker.contract = contract,
    worker.email = data.email,
    worker.email_verified_at = null,
    worker.full_name = data.name + ' ' + data.surname,
    worker.got_car = (data.got_car) ? 1 : 0,
    worker.name = data.name,
    worker.num_hours = (data.num_hours) ? data.num_hours : null,
    worker.phone = data.phone,
    worker.role = role,
    worker.status = status,
    worker.surname = data.surname

    return worker

}

export const saveWorker = (worker, data) => {

    worker.address = data.address,
    worker.app_access = data.app_access,
    worker.badge_number = (data.badge_number) ? data.badge_number : null,
    worker.city = data.city,
    worker.contract = data.contract,
    worker.email = data.email,
    worker.email_verified_at = null,
    worker.full_name = data.name + ' ' + data.surname,
    worker.got_car = (data.got_car) ? 1 : 0,
    worker.name = data.name,
    worker.num_hours = (data.num_hours) ? data.num_hours : null,
    worker.phone = data.phone,
    worker.role = data.role,
    worker.status = data.status,
    worker.surname = data.surname
}

export const setShop = (data, status) => {

    var shop = {}

    shop.full_name = data.full_name,
    shop.inspector_id = data.inspector_id,
    shop.director_name = data.director_name,
    shop.director_phone = data.director_phone,
    shop.address = data.address,
    shop.city = data.city,
    shop.group_id = data.group_id,
    shop.num_monthly_hours = data.num_monthly_hours,
    shop.status = status

    return shop
}

export const setEmptyDaysOff = () => {
    return {
        'monday': 0,
        'tuesday': 0,
        'wednesday': 0,
        'thursday': 0,
        'friday': 0,
        'saturday': 0,
        'sunday': 0,
    }
}
